import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, MessageCircle, Mail } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const Footer = () => {
    const { settings } = useSettings();
    if (!settings) return null;
    const phone = settings.phone;
    const wa = (settings.whatsapp || phone).replace(/[^\d]/g, "");

    return (
        <footer data-testid="site-footer" className="bg-bg-base border-t border-white/10 pt-20 pb-8 px-6 md:px-12">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                        {settings.logo_url ? (
                            <img src={settings.logo_url} alt="Star Events" className="h-10" />
                        ) : (
                            <>
                                <span className="text-3xl gold-text-gradient font-serif font-bold">★</span>
                                <div>
                                    <div className="font-serif text-lg font-bold text-white">Star Events</div>
                                    <div className="text-[10px] tracking-[0.25em] uppercase text-gold/80">Sales & Service</div>
                                </div>
                            </>
                        )}
                    </div>
                    <p className="text-sm text-white/60 leading-relaxed">{settings.footer_about}</p>
                </div>

                <div>
                    <h4 className="text-gold uppercase tracking-[0.2em] text-xs mb-5">Quick Links</h4>
                    <ul className="space-y-3 text-sm text-white/70">
                        <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
                        <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
                        <li><Link to="/services" className="hover:text-gold transition-colors">Services</Link></li>
                        <li><Link to="/gallery" className="hover:text-gold transition-colors">Gallery</Link></li>
                        <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-gold uppercase tracking-[0.2em] text-xs mb-5">Get In Touch</h4>
                    <ul className="space-y-3 text-sm text-white/70">
                        <li className="flex gap-3"><MapPin size={16} className="text-gold mt-0.5 shrink-0" /><span>{settings.address}</span></li>
                        <li className="flex gap-3"><Phone size={16} className="text-gold mt-0.5 shrink-0" /><a href={`tel:${phone}`} className="hover:text-gold">{phone}</a></li>
                        <li className="flex gap-3"><MessageCircle size={16} className="text-gold mt-0.5 shrink-0" /><a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="hover:text-gold">WhatsApp Us</a></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-gold uppercase tracking-[0.2em] text-xs mb-5">Follow</h4>
                    <div className="flex items-center gap-3 mb-6">
                        <a href={settings.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 grid place-items-center rounded-full border border-white/15 hover:border-gold hover:text-gold transition-colors">
                            <Instagram size={18} />
                        </a>
                        <a href={settings.google_maps_url} target="_blank" rel="noreferrer" data-testid="footer-map" className="w-10 h-10 grid place-items-center rounded-full border border-white/15 hover:border-gold hover:text-gold transition-colors">
                            <MapPin size={18} />
                        </a>
                    </div>
                    <div className="text-xs text-white/50">{settings.business_hours}</div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
                <div>© {new Date().getFullYear()} {settings.company_name}. All rights reserved.</div>
                <div><Link to="/admin/login" className="hover:text-gold transition-colors">Admin</Link></div>
            </div>
        </footer>
    );
};

export default Footer;
